export default __webpack_public_path__ + "static/media/005-can.ac8b1e13.svg";